<template>
  <div id="companyBasic">
    <a-form
      ref="step1Ref"
      class="ant-round-form material-company-register-form"
      layout="vertical"
      :model="modelForm"
      :rules="rules"
      @finish="submit"
    >
      <a-form-item name="merchantRegistrationType" style="text-align: center" :label="$t('pages_merchant_154')">
        <a-select
          v-model:value="modelForm.merchantRegistrationType"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.merchantRegistrationTypeDisabled"
        >
          <a-select-option v-for="item in merchantRregistrationType" :key="item.value" :value="item.value">{{ item.key
          }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.merchantRegistrationTypeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.merchantRegistrationTypeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 持牌法团fi 填写内容 -->
      <div v-if="modelForm.merchantRegistrationType === '01'">
        <a-form-item name="relyThird" style="text-align: center" :label="$t('pages_merchant_205')">
          <a-select
            v-model:value="modelForm.relyThird"
            show-search
            size="large"
            option-filter-prop="label"
            :disabled="modelForm.merchantRegistrationTypeDisabled"
          >
            <a-select-option v-for="item in fiType" :key="item.value" :value="item.value">{{ item.key
            }}</a-select-option>
          </a-select>
          <div v-if="!modelForm.merchantRegistrationTypeDisabled && refused" class="error-area">
            <exclamation-circle-outlined class="ic-error" />
            <span>{{ modelForm.merchantRegistrationTypeMessage }}</span>
          </div>
        </a-form-item>
        <a-form-item name="complianceAudit" style="text-align: center" :label="$t('pages_merchant_206')">
          <a-select
            v-model:value="modelForm.complianceAudit"
            show-search
            size="large"
            option-filter-prop="label"
            :disabled="modelForm.complianceAuditDisabled"
          >
            <a-select-option v-for="item in fiType" :key="item.value" :value="item.value">{{ item.key
            }}</a-select-option>
          </a-select>
          <div v-if="!modelForm.complianceAuditDisabled && refused" class="error-area">
            <exclamation-circle-outlined class="ic-error" />
            <span>{{ modelForm.complianceAuditMessage }}</span>
          </div>
        </a-form-item>
        <a-form-item
          v-if="modelForm.complianceAudit === '1'"
          name="latestAuditReportPath"
          :label="$t('pages_merchant_207')"
        >
          <upload-auto
            ref="uploadLRef"
            v-model:file-content="modelForm.latestAuditReportPath"
            accept=".jpg,.jpeg,.png,.pdf,.bmp"
            type="INVITE"
            list-type="picture"
            back-type="array"
            :disabled="modelForm.latestAuditReportPathDisabled"
            :explain="$t('pages_merchant_032')"
            :max-count="5"
          />
          <div v-if="!modelForm.latestAuditReportPathDisabled && refused" class="error-area">
            <exclamation-circle-outlined class="ic-error" />
            <span>{{ modelForm.latestAuditReportPathMessage }}</span>
          </div>
        </a-form-item>
        <a-form-item name="amlPolicyPath" :label="$t('pages_merchant_208')">
          <upload-auto
            ref="uploadARef"
            v-model:file-content="modelForm.amlPolicyPath"
            accept=".jpg,.jpeg,.png,.pdf,.bmp"
            type="INVITE"
            list-type="picture"
            back-type="array"
            :disabled="modelForm.amlPolicyPathDisabled"
            :explain="$t('pages_merchant_032')"
            :max-count="5"
          />
          <div v-if="!modelForm.amlPolicyPathDisabled && refused" class="error-area">
            <exclamation-circle-outlined class="ic-error" />
            <span>{{ modelForm.pamlPolicyPathMessage }}</span>
          </div>
        </a-form-item>
        <a-form-item name="licensePathOrProofPaymentPath" :label="$t('pages_merchant_209')">
          <upload-auto
            ref="uploadQRef"
            v-model:file-content="modelForm.licensePathOrProofPaymentPath"
            accept=".jpg,.jpeg,.png,.pdf,.bmp"
            type="INVITE"
            list-type="picture"
            back-type="array"
            :disabled="modelForm.licensePathOrProofPaymentPathDisabled"
            :explain="$t('pages_merchant_032')"
            :max-count="5"
          />
          <div v-if="!modelForm.licensePathOrProofPaymentPathDisabled && refused" class="error-area">
            <exclamation-circle-outlined class="ic-error" />
            <span>{{ modelForm.licensePathOrProofPaymentPathMessage }}</span>
          </div>
        </a-form-item>
        <a-form-item name="amlQuestionPath" :label="$t('pages_merchant_210')">
          <upload-auto
            ref="uploadPRef"
            v-model:file-content="modelForm.amlQuestionPath"
            accept=".jpg,.jpeg,.png,.pdf,.bmp"
            type="INVITE"
            list-type="picture"
            back-type="array"
            :disabled="modelForm.amlQuestionPathDisabled"
            :explain="$t('pages_merchant_032')"
            :max-count="5"
          />
          <div v-if="!modelForm.amlQuestionPathDisabled && refused" class="error-area">
            <exclamation-circle-outlined class="ic-error" />
            <span>{{ modelForm.amlQuestionPathMessage }}</span>
          </div>
        </a-form-item>
      </div>

      <!-- 公司注册地址 -->
      <a-form-item name="registrationAddress" :label="$t('pages_merchant_155')">
        <a-input
          v-model:value="modelForm.registrationAddress"
          size="large"
          allow-clear
          :disabled="modelForm.registrationAddressDisabled"
          :placeholder="$t('pages_merchant_179')"
        />
        <div v-if="!modelForm.registrationAddressDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.registrationAddressMessage }}</span>
        </div>
      </a-form-item>
      <!-- 真实经营地址与注册地址是否一致 -->
      <a-form-item name="truthSwitch" :label="$t('pages_merchant_182')">
        <a-switch v-model:checked="modelForm.truthSwitch" checked-children="是" un-checked-children="否" :disabled="modelForm.truthSwitchDisabled" />
      </a-form-item>
      <a-form-item name="companyAddressType" style="text-align: center" :label="$t('pages_merchant_156')">
        <a-select
          v-model:value="modelForm.companyAddressType"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.companyAddressTypeDisabled"
        >
          <a-select-option v-for="item in companyAddressType" :key="item.value" :value="item.value">{{ $t(item.key)
          }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.companyAddressTypeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.companyAddressTypeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 真实营业地址 -->
      <a-form-item v-if="!modelForm.truthSwitch" name="mailingAddress" :label="$t('pages_holder_070')">
        <a-input
          v-model:value="modelForm.mailingAddress"
          size="large"
          allow-clear
          :disabled="modelForm.merchantNameEnDisabled"
          :placeholder="$t('pages_merchant_179')"
        />

      </a-form-item>
      <!-- 上传 -->
      <a-form-item name="proofOfRealBusinessAddress" :label="$t('pages_merchant_157')">
        <div class="explain" style="margin-bottom: 24px">
          <span>{{ $t('pages_merchant_035') }}</span>
          <a-popover title="请按要求提供以下其中一份文件验证您的经营地址">
            <template #content>
              <p>可接受的地址验证文件清单：</p>
              <p>1.最有效营业证明：同名公司银行对账单附地址的首页. (日期不超过3个月)</p>
              <p>2.同名公司的官方水电费账单附有地址. (日期不超过3个月)</p>
              <p>3.具联系地址的公司官方网站, 产品目录, 服务册子, 广告单, 宣传单</p>
              <p>4.UBO 的银行账户证明. (日期不超过3个月)</p>
              <p>5.提供中国自营或有直接业务联系公司,其商品的业务性质应与香港公司匹配。</p>
              <p v-if="modelForm.truthSwitch">
                <span v-if="modelForm.companyAddressType === '1'">6.租约，或与秘书公司的服务协议（包含产品和服务内容允许在秘书公司场所办公）</span>
                <span v-else>6.租约。</span>
              </p>
              <p v-if="modelForm.truthSwitch">
                <span v-if="modelForm.companyAddressType === '1'">7.不少于两张带有公司标志的办公室实景照片，并附上可确认的地址信息。（a.楼<br>宇外观/b.门牌号
                  Google Maps /高德地图截图/c.手机照片水印 三选一）</span>
                <span v-else>7.不少于两张带有公司标志的办公室实景照片，并附上可确认的地址信息。（a.楼<br>宇外观/b.门牌号 Google Maps/高德地图截图/c.手机照片水印
                  三选一）。</span>
              </p>
            </template>
            <span type="primary" style="color: #BA8438">{{ $t('pages_merchant_183') }}</span>
          </a-popover>
          <span>{{ $t('pages_merchant_047') }}{{ $t('pages_merchant_157') }}{{ $t('pages_merchant_048') }}</span>
        </div>
        <upload-auto
          ref="uploadRef"
          v-model:file-content="modelForm.proofOfRealBusinessAddress"
          accept=".jpg,.jpeg,.png,.pdf,.bmp"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.proofOfRealBusinessAddressDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.proofOfRealBusinessAddressDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.proofOfRealBusinessAddressMessage }}</span>
        </div>
      </a-form-item>
      <a-form-item style="text-align: right">
        <a-button html-type="submit" type="primary" shape="round" style="min-width: 138px; margin-top: 24px">{{
          $t('pages_merchant_020') }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed, onUnmounted, nextTick } from 'vue'
import companyAddressType from '@/common/companyAddressType'
import merchantRregistrationType from '@/common/merchantRregistrationType'
import UploadAuto from '@/components/upload-auto'
import i18n from '@/locale'
export default {
  name: 'CompanyBasic',
  components: {
    'upload-auto': UploadAuto
  },
  props: {
    model: {
      type: Object,
      default: () => { return {} }
    },
    refused: {
      type: Boolean,
      default: () => { return false }
    },
    countries: {
      type: Array,
      default: () => { return [] }
    }
  },
  setup(props, ctx) {
    const fiType = [
      {
        value: '0',
        key: '否'
      },
      {
        value: '1',
        key: '是'
      }]
    const timer = null
    const uploadRef = ref(null)
    const uploadLRef = ref(null)
    const uploadARef = ref(null)
    const uploadQRef = ref(null)
    const uploadPRef = ref(null)
    const step1Ref = ref(null)
    const state = reactive({
      exist: false,
      language: localStorage.getItem('locale-language') || 'zh',
      rules: {
        registrationAddress: [{ required: true, message: i18n.global.t('pages_merchant_155') }, {
          pattern: new RegExp(/^[ ,.0-9A-Za-z]+$/),
          message: i18n.global.t('pages_holder_071')
        }],
        mailingAddress: [{ required: true, message: i18n.global.t('pages_holder_070') }, {
          pattern: new RegExp(/^[ ,.0-9A-Za-z]+$/),
          message: i18n.global.t('pages_holder_071')
        }],
        proofOfRealBusinessAddress: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_merchant_157') }],
        latestAuditReportPath: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_merchant_207') }],
        amlPolicyPath: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_merchant_208') }],
        amlQuestionPath: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_merchant_210') }],
        licensePathOrProofPaymentPath: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_merchant_209') }]
      }
    })

    state.modelForm = computed(() => {
      return props.model
    })

    onUnmounted(() => {
      clearInterval(timer)
    })

    const submit = () => {
      ctx.emit('next', '2-1')
    }

    nextTick(() => {
      const { proofOfRealBusinessAddress, latestAuditReportPath, amlPolicyPath, amlQuestionPath, licensePathOrProofPaymentPath } = state.modelForm
      if (proofOfRealBusinessAddress.length !== 0 && uploadRef.value) uploadRef.value.fileListRefresh(proofOfRealBusinessAddress)
      if (latestAuditReportPath.length !== 0 && uploadLRef.value) uploadLRef.value.fileListRefresh(latestAuditReportPath)
      if (amlPolicyPath.length !== 0 && uploadARef.value) uploadARef.value.fileListRefresh(amlPolicyPath)
      if (amlQuestionPath.length !== 0 && uploadQRef.value) uploadQRef.value.fileListRefresh(amlQuestionPath)
      if (licensePathOrProofPaymentPath.length !== 0 && uploadPRef.value) uploadPRef.value.fileListRefresh(licensePathOrProofPaymentPath)
    })
    return {
      fiType,
      step1Ref,
      submit,
      uploadRef,
      uploadLRef,
      uploadARef,
      uploadQRef,
      uploadPRef,
      companyAddressType,
      merchantRregistrationType,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#companyBasic {}
</style>
